import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { CommonService } from "../../services/commonService";

@Injectable({
  providedIn: "root",
})
export class ChatbotService {
  constructor(private commonService: CommonService) {}

  getChatbotUrl(): Observable<string> {
    const body = { dropdown: [""] };
    return this.commonService.getDropdownValues(body).pipe(
      map((res) => {
        if (res.message.errorMessage !== "") {
          throw new Error(res.message.errorMessage || "Failed to fetch chatbot URL");
        }

        const token = this.commonService.getAccessToken();
        const tokenEndpoint = encodeURIComponent(
          `${environment.baseApiUrl}api/svl-chatbot-token?userToken=${token}`,
        );
        return `${res.list.fullChatbotUrl}${tokenEndpoint}`;
      }),
    );
  }

  getHistory(page: number, size: number): Observable<any> {
    return this.commonService.getChatbotHistory(page, size);
  }

  appendConversationId(chatbotUrl: string, conversationId: string): string {
    const separator = chatbotUrl.includes("?") ? "&" : "?";
    return `${chatbotUrl}${separator}conversation_id=${conversationId}`;
  }

  buildWorkspaceUrl(conversationId?: string | null): string {
    const query = conversationId ? `?conversationId=${encodeURIComponent(conversationId)}` : "";
    return `${window.location.origin}${window.location.pathname}#/chatbot-workspace${query}`;
  }

  openWorkspaceInNewTab(conversationId?: string | null) {
    window.open(this.buildWorkspaceUrl(conversationId), "_blank");
  }
}
